<template>
    <div class="warning-block" v-if="msg !== undefined && msg.length > 0">

        <div class="relative">
            <div class="text-block" v-for="(m, key) in getMessages" :key="key">
                <p class="warning-text" :style="nore10" :class="{ error: !isInfo, info: isInfo }">
                    {{ m }}
                </p>
                <img v-if="!isInfo" :src="errorIcon" />
            </div>
        </div>

    </div>
</template>

<script setup lang="ts">
import { getIcon } from '@/helpers/api';
import { getFont } from '@/helpers/fonts';
import { StyleValue, computed, onBeforeMount, ref } from 'vue'

const props = defineProps({
    msg: { type: [String, Array<string>], default: undefined },
    isInfo: { type: Boolean, default: false },
})

const errorIcon = ref<string>()
const nore10 = ref<StyleValue>()

onBeforeMount(async () => {
    nore10.value = await getFont('nore10') as StyleValue
    errorIcon.value = await getIcon("1120", "error_icon")
})

const getMessages = computed(() => Array.isArray(props.msg) ? props.msg : [props.msg])

</script>

<style scoped>
.warning-block {
    margin-top: 1%;
    width: 100%;
    height: auto;
    display: flex;

    justify-content: flex-end;
}

.relative {
    position: relative;
    max-width: 100%;
}

.warning-text {
    color: var(--ion-color-danger);
    margin: 0px;
    max-height: 100%;
    max-width: 100%;
}

img {
    height: 100%;
    display: block;
}

.text-block {
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
}

.warning-text.info {
    color: var(--ion-color-primary);
    margin: 0px;
    max-height: 100%;
    max-width: 100%;
}

</style>